import {
  FilterTypeToFilter,
  FilterType,
  FilterTypeSearch,
} from '../common/filters-utils/filters-utils';

export const sbomFilters = [
  {
    type: FilterTypeToFilter.Apps,
    header: FilterType.apps,
    searchType: FilterTypeSearch.apps,
  },
  {
    type: FilterTypeToFilter.PackageNames,
    header: FilterType.packageNames,
    searchType: FilterTypeSearch.packageNames,
  },
  {
    type: FilterTypeToFilter.LibraryNames,
    header: FilterType.libraryNames,
    searchType: FilterTypeSearch.libraryNames,
  },
  {
    type: FilterTypeToFilter.LibraryVersions,
    header: FilterType.libraryVersions,
    searchType: FilterTypeSearch.libraryVersions,
  },
  {
    type: FilterTypeToFilter.Licenses,
    header: FilterType.licenses,
  },
  {
    type: FilterTypeToFilter.DependencyTypes,
    header: FilterType.dependencyTypes,
  },
  {
    type: FilterTypeToFilter.Source,
    header: FilterType.source,
  },
];
